import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { EndoInvModel } from '../models/EndoInvModel';
import { EndoTypeModel } from '../models/EndoInvModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class EndoInvService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getEndoInvAll(endoinvcode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("EndoInvCode", endoinvcode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<EndoInvModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/EndoInv/GetEndoInv',options);
    }


    public AddEndoInv(endoInv: EndoInvModel) {
      return this.http.post<EndoInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/EndoInv/AddEndoInv', endoInv);
    }

    public delEndoInv_Line(endoinvcode: string ,endoinvdate: string, endoinvtype:string ,compcode: string) {

    let params = new HttpParams();
    params = params.append("EndoInvCode", endoinvcode);
    params = params.append("EndoInvDate", endoinvdate);
    params = params.append("EndoInvType", endoinvtype);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.delete<EndoInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/EndoInv/DeleteEndoInv',options);
    }

    public getEndoTypeLookupTop() {
      let params = new HttpParams();
      const options = {
          params: params
      };
      return this.http.get<EndoTypeModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/EndoInv/EndoTypeLookupTop', options);
  }
  }
